'use client';

interface EmptyValueProps {
  message?: string;
}

export function EmptyValue({ message = 'Non renseigné' }: EmptyValueProps) {
  return (
    <span className="text-xs font-medium italic text-muted-foreground/70 dark:text-muted-foreground/60">
      {message}
    </span>
  );
}

